
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type pageTitleRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function pageTitleRT(): TemplateResult<pageTitleRTRootProps> {
    return _createElement('h1', { 'className': 'page-heading' }, this.template === 'active' ? _createElement('div', {
        'className': 'cmTemplate_active',
        'key': '28'
    }, 'Search') : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cmTemplate_locked',
        'key': '119'
    }, 'Search Results for') : null);
}
        export const componentNames = []